<app-nav></app-nav>
<div
  class="page-body-config"
  role="main"
>
  <header>
    <h1 class="page-header">Watch Live!</h1>
  </header>
  <div class="body-container mx-auto">
    <app-camper-cams
      *ngIf="step === 0"
      (changeStep)="handlePageContent($event)"
    ></app-camper-cams>
    <app-camper-cams-change-location
      *ngIf="step === 1"
      (changeStep)="handlePageContent($event)"
    ></app-camper-cams-change-location>
    <app-camper-cams-search-location
      *ngIf="step === 2"
      (changeStep)="handlePageContent($event)"
    ></app-camper-cams-search-location>
  </div>
</div>
<app-footer></app-footer>